import styled from 'styled-components';
import { Spacing } from '@atomic/obj.constants';
export const BookingTD = styled.td `
  padding: ${Spacing.XSmall};
`;
export const BookingTR = styled.tr `
  height: 34px;
  min-height: 34px;
`;
